import functions from "./functions";

$(() => {
    searchOffer.init();
});

const searchOffer = {
    params: {
        objectGroupId: 1,
        perPage: 10,
        _page: 1,
        template: 'search_offer',
        objectName: null,
        objectNameSearched: null,
        _pageSearched: null,
        //dynamicPackage: 1,
    },
    $searchOfferResults: null,
    $btnSearchOfferResults: null,
    $btnSearchOffer: null,
    $form: null,
    init() {

        this.$searchOfferResults = $('.search-offer-results');

        if(! this.$searchOfferResults.length) return;

        this.$form = $('form#search-offer');
        this.form = this.$form[0];

        this.$btnSearchOffer = $('.btn-search-offer');
        this.$btnSearchOfferResults = $('#btn-search-offer-results');
        
        this.$form.on('submit', e => {
            e.preventDefault();
            e.stopPropagation();

            this.params._page = 1;
            let formData = functions.getFormData(this.$form);
            this.params = $.extend({}, this.params, formData);

            this.$btnSearchOfferResults.dropdown('show');
            this.find();
        });

        let clickStartedInside = null;
        let clickFinishedOutside = null;

        $(document).on('mousedown', e => {
            clickStartedInside = $(e.target).closest('.search-offer').length;
        });
        $(document).on('mouseup', e => {
            clickFinishedOutside = ! $(e.target).closest('.search-offer').length;
            ! clickStartedInside && this.$btnSearchOffer.dropdown('hide');
            clickStartedInside = clickFinishedOutside = null;
        });

        this.$btnSearchOfferResults.on('hidden.bs.dropdown', e => {
            this.params._page = 1;
            this.$searchOfferResults.empty();
            this.params.objectNameSearched = null;
        });

        this.$btnSearchOffer.on('hide.bs.dropdown', e => {
            $('.dropdown-search').addClass('closing');
            setTimeout(() => {
                $('.dropdown-search').removeClass('closing');
            }, 300);
        });

        this.$btnSearchOffer.on('hidden.bs.dropdown', e => {
            this.params.objectName = null;
            functions.setFormData(this.form, this.params);
            this.$btnSearchOfferResults.dropdown('hide');
        });

        this.$btnSearchOffer.on('shown.bs.dropdown', e => {
            this.$form.find('[name="objectName"]').focus();
        });

        this.$searchOfferResults.on('click', '[data-page-offer]', e => {
            e.preventDefault();
            this.params._page = +$(e.currentTarget).attr('data-page-offer');
            this.find();
        });
    },
    find() {
        if (this.params.objectNameSearched === this.params.objectName && this.params._pageSearched === this.params._page) return;

        this.$searchOfferResults.html(`<div class="spinner-border text-primary mt-5" role="status"><span class="visually-hidden">Loading...</span></div>`);
        let params = this.params;

        params['recaptchaType'] = 'enterprise';

        grecaptcha.enterprise.ready(function () {
            grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'search_offer' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                $.get('/services/search_offer/', params)
                    .done(response => {
                        response = JSON.parse(response);
                        searchOffer.$searchOfferResults.html(response.html);

                        if(response.total) {
                            window.observer.observe();

                            $('.paginate-offer').html(searchOffer.pagination({
                                currentPage: params._page,
                                total: response.total,
                                perPage: params.perPage
                            }));
                        } else {
                            params.objectName && $('.search-object-name').text('"' + params.objectName + '"');
                        }

                        searchOffer.params.objectNameSearched = params.objectName;
                        searchOffer.params._pageSearched = params._page;

                    })
                    .fail(e => {
                        console.log(e);

                        params._page = 1;
                        searchOffer.$searchOfferResults.html(
                            `<div class="no-offer-results">
                        <i class="las la-search"></i>
                        <p class="mb-2">Nema rezultata za pretragu <span class="search-object-name">"${ params.objectName }"</span></p>
                        <p class="small">Pokušajte s drugim ključnim riječima.</p>
                    </div>`
                        );
                    });
            });
        });

    },
    pagination(params) {
        const numberOfPages = Math.ceil(params.total / params.perPage);
        params.displayedPages = 4;
        
        let start = Math.max(1, params.currentPage - Math.abs(Math.floor(params.displayedPages / 2)));
        let end = start + params.displayedPages;

        if (end > numberOfPages) {
            end = numberOfPages + 1;
            start = Math.max(1, end - params.displayedPages);
        }

        const pages = [];

        for (let i = start; i < end; i++) {
            pages.push(i);
        }

        return `            
            <ul class="pagination justify-content-center">
                <!-- prev page -->                
                <li class="page-item prev-page ${ params.currentPage == start ? `disabled` : `` }">
                    <a class="page-link h-100" href="#_page=${params.currentPage - 1}" aria-label="Previous" data-page-offer="${params.currentPage - 1}">
                        <i class="fa-light fa-angle-left fa-lg"></i>
                    </a>
                </li>
                <!-- first page -->
                ${numberOfPages && pages[0] != 1 ? `
                    <li class="page-item first-page"><a class="page-link" href="#_page=1" data-page-offer="1">1</a></li>
                ` : ``}
                <!-- pages -->
                ${pages.map(page => `
                    <li class="page-item${page == params.currentPage ? ` active` : ``}${ page == pages.length + 1 ? ` last-page` : `` }"><a class="page-link" href="#_page=${page}" data-page-offer="${page}">${page}</a></li>
                `).join("")}
                <!-- last page -->
                ${numberOfPages && pages[pages.length - 1] != numberOfPages ? `
                    ${ numberOfPages - pages[pages.length - 1]  > 1 ? '<li class="page-item"><a class="page-link px-2">...</a></li>' : ''}
                    <li class="page-item last-page"><a class="page-link" href="#_page=${numberOfPages}" data-page-offer="${numberOfPages}">${numberOfPages}</a></li>
                ` : ``}
                <!-- next page -->
                <li class="page-item next-page ${ params.currentPage + 1 == end ? `disabled` : `` }">
                        <a class="page-link h-100" href="#_page=${params.currentPage + 1}" aria-label="Next" data-page-offer="${params.currentPage + 1}">
                            <i class="fa-light fa-angle-right fa-lg"></i>
                        </a>
                </li>
            </ul>
        `;
    },
};